import styles from './Partner.module.scss';
import cn from 'classnames';
import pic from '../../resources/pics/art.png';
import blank from '../../resources/pics/blank.jpg';
import {Link} from "../Link/Link";

const kaspersky = 'https://allsoft.kaspersky.ru/basket/add/4669584?clear=Y&reseller=kl-ru_22ru-2X2_pro_ona_oth__onl_b2c_2x2_lnk_2x2___kis___';

export const Partner = () => {
    return (
        <div className={styles.partner}>
            <div className={styles.info}>
                <div className={styles.title}>Прокачай антикиберкринж</div>
                <div className={styles.desc}>Дарим <Link link={kaspersky} text="Kaspersky Internet Security" className="" /><br/> на 2 месяца:</div>
                <ul className={styles.list}>
                    <li className={styles.item}>Играй без просадок FPS</li>
                    <li className={styles.item}>Не дай сайтам собрать о тебе инфу</li>
                    <li className={styles.item}>Плати онлайн безопасно</li>
                </ul>
                <div className={styles.desc}>И забудь о кринжовых историях в сети!</div>
                <Link link={kaspersky} text="Прокачать" className={styles.button} />
            </div>
            <img src={pic} className={styles.pic} alt="Антикиберкринж"/>
            <a href={kaspersky} target="_blank" rel="nofollow noreferrer" className={cn(styles.link, 'partner-link')}>
                <img src={blank} alt="Kaspersky Internet Security"/>
            </a>
        </div>
    )
}